import {nativeSubmitWithCsrf} from './csrf';
import {getElementById} from './dom';

export function setupListPaymentsReconcile(): void {
    const reconcileBtn = getElementById('reconcile_payment_bank_trxn_btn');
    const paymentListForm = getElementById<HTMLFormElement>('payment_list');
    if (!reconcileBtn || !paymentListForm) {
        return;
    }

    const customerRef = reconcileBtn.dataset.bankCustomerRef ?? '';

    reconcileBtn.addEventListener('click', () => {
        const checkedCount = document.querySelectorAll('input[name="payments[]"]:checked').length;
        if (!checkedCount) {
            swal(
                'No payment was selected',
                'Please select any payment to reconcile to the bank transaction',
                'info',
            );
            return;
        }

        swal(
            {
                title: `Do you want to reconcile these payment(s) with \nBank Transaction '${customerRef}'?`,
                text: 'Click yes to continue',
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#27c24c',
                confirmButtonText: 'Yes, confirm',
                cancelButtonText: 'No, cancel',
                closeOnConfirm: false,
                closeOnCancel: false,
            },
            (isConfirm: boolean) => {
                if (isConfirm) {
                    paymentListForm.action = '/admin/reconcilepayment';
                    nativeSubmitWithCsrf(paymentListForm);
                    return;
                }
                swal('Cancelled', 'Cancel reconciling payment', 'error');
            },
        );
    });
}
